import { Component, OnInit, Inject, Input, OnDestroy } from '@angular/core';
import {  MatDialogRef, MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { UploadfileComponent } from '../uploadfile/uploadfile.component';

@Component({
    selector: 'app-addfiledialog',
    templateUrl: './addfiledialog.component.html',
    styleUrls: ['./addfiledialog.component.scss'],
    standalone: true,
    imports: [
      CommonModule, 
      FormsModule, 
      UploadfileComponent,
      MatDialogModule
    ]
})
export class AddfiledialogComponent implements OnInit, OnDestroy {
  url: string = "";
  storageUrl: string = "";
  isUploaded = false
  organizationKey = "";
  contentKey = "";
  userId = "";
  @Input()projectKey: string = "";
  @Input()projectName: string = "";
  @Input() embeddingModel = "gemini-embedding-001"
  @Input() closeAfterImageCapture: boolean = false
  @Input() imagesOnly: boolean = false


  constructor(public dialogRef: MatDialogRef<AddfiledialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.organizationKey = data.organizationKey
    this.contentKey = data.contentKey
    this.userId = data.userId
    this.closeAfterImageCapture = data.closeAfterImageCapture
    this.imagesOnly = data.imagesOnly
  }

  ngOnInit(): void {

  }

  convertDocxToText() { // to jest wrzucone narazie na próbę https://www.npmjs.com/package/mammoth
    var mammoth = require("mammoth");
    mammoth.convertToHtml({path: "path/to/document.docx"})
    .then((result: any) => {
        var html = result.value; // The generated HTML
        var messages = result.messages; // Any messages, such as warnings during conversion
    })
    .catch((error: any) => {
        console.error(error);
    });
  }

  isFileUploaded(arg: {"isFileUploaded": boolean, "url": string, "storageUrl": string}) { // fired when file is uploaded to a new comment
    this.url = arg.url
    this.storageUrl = arg.storageUrl
    this.isUploaded = arg.isFileUploaded
      this.data.url = arg.url
      this.data.storageUrl = arg.storageUrl
      this.dialogRef.close(this.data);
  }

  ngOnDestroy(): void {
  }

  onAddClick() {
    this.data.url = this.url
    this.data.storageUrl = this.storageUrl
    this.dialogRef.close();
  }

  onExitClick() {
    this.data.url = this.url
    this.data.storageUrl = this.storageUrl
    this.dialogRef.close(this.data);
  }

}
